export const FIRST_NAME_KEY = 'first_name'
export const MIDDLE_NAME_KEY = 'middle_name'
export const LAST_NAME_KEY = 'last_name'
export const PHONE_KEY = 'phone'
export const DATE_BIRTH_KEY = 'date_of_birth'
export const ACCOUNT_PIN_KEY = 'account_pin'
export const EMAIL_KEY = 'email'

export const PHONE_ERROR_MESSAGE = 'Enter a valid Australian phone number, e.g. 0411111111'
export const DATE_ERROR_MESSAGE = 'Enter a valid date, e.g. for 10 December 1990 enter 10/12/1990'
export const ACCOUNT_PIN_ERROR_MESSAGE = 'Account PIN must be 4 digits.'

export const REQUIRED_ERROR_MESSAGE = 'This field is required'
export const DEFAULT_RESPONSE_ERROR = 'We encountered an issue while trying to save your details, please try again'

export const GA_CATEGORY = 'Personal'



// WEBPACK FOOTER //
// ./containers/stages/PersonalInfoStage/constants.js